import _ from 'lodash';
import { useSelector } from 'react-redux';

import { reportGetByDate } from 'api/endpoints/report';
import { handleError } from 'utils/helper';

const useReport = () => {
  const { childrenDetail } = useSelector((state) => state.children);

  const getReportByDate = async (queryString = '') => {
    try {
      const response = await reportGetByDate(childrenDetail?.id, queryString);
      if (response?.data) {
        const sortedCreatedAt = _.sortBy(response.data, '-created_at');
        return sortedCreatedAt;
      }
      return [];
    } catch (error) {
      handleError(error);
    }
  };

  return { getReportByDate };
};

export default useReport;
